import CitiesListPageContainer from './containers/CitiesListPageContainer'

export default CitiesListPageContainer
